import { useQuery } from 'react-query';
import axios from 'axios';
import Http from '../services/http';

interface RequestType {
  RequestType: string;
  RequestTypeName: string;
}

export const useRequestTypes = (clientCode?: string) => {
  return useQuery<RequestType[]>(
    ['requestTypes', clientCode],
    async () => {
      const params = new URLSearchParams();
      if (clientCode) {
        params.append('client_code', clientCode);
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_API}/request-types?${params}`,
        {
          headers: {
            Authorization: `Bearer ${Http.accessToken}`,
          },
        }
      );
      return data;
    },
    {
      staleTime: 5 * 60 * 1000, // 5 minutes
      enabled: !!clientCode, // Only fetch when we have a client code
      refetchOnWindowFocus: false,
    }
  );
};
